import Popover from "@/components/Popover";
import { useGetUnreadCount } from "@/hooks";
import React, { useEffect } from "react";
import { IoMdNotifications } from "react-icons/io";
import { ListMyNotification } from "./ListMyNotification";
const NotificationPanel: React.FC = () => {
  const { unreadCount, refetch } = useGetUnreadCount();

  // Refetch unread count on mount
  useEffect(() => {
    refetch();
  }, []);

  // Show/hide notification panel in mobile
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);

  // Open panel when click on notification icon in mobile
  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };

  // Update document title with unread count
  useEffect(() => {
    if (unreadCount && unreadCount > 0) {
      const currentTitle = document.title.replace(/^\(\d+\)\s*/, "");
      document.title = `(${unreadCount}) ${currentTitle}`;
    } else {
      document.title = document.title.replace(/^\(\d+\)\s*/, "");
    }
  }, [unreadCount]);

  return (
    <div>
      {/* Mobile Notification Panel  */}
      <div className="block sm:hidden">
        <NotificationIcon unreadCount={unreadCount} onPress={togglePanel} />

        {/* Notification List  */}
        {isPanelOpen && (
          <div className="fixed inset-0 bg-white z-30">
            <ListMyNotification onClose={togglePanel} />
          </div>
        )}
      </div>

      {/* Desktop Notification Panel  */}
      <div className="hidden sm:block">
        <Popover
          side="bottom"
          align="end"
          trigger={<NotificationIcon unreadCount={unreadCount} />}
          triggerClassName="flex items-center justify-center"
          contentClassName="shadow-light_dropdown bg-white w-full sm:w-[320px] insect-0 z-30"
          enableCloseOnClick={false}
        >
          {/* Notification List  */}
          <ListMyNotification />
        </Popover>
      </div>
    </div>
  );
};

const NotificationIcon = ({
  unreadCount,
  onPress,
}: {
  unreadCount: number;
  onPress?: () => void;
}) => (
  <div
    className="cursor-pointer hover:opacity-70 transition-opacity duration-200"
    onClick={onPress}
  >
    <IoMdNotifications className="size-6 text-cyan" />
    {!!unreadCount && (
      <div className="min-w-3 px-[2px] rounded-lg flex items-center justify-center bg-red-500 text-white absolute -top-0.5 -right-0.5 text-[8px] leading-3 text-dark_primary  ">
        {unreadCount}
      </div>
    )}
  </div>
);

export default NotificationPanel;
